import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGamepadControlsRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGamepadControlsRight"><Path d="M16 2H8V7.16421L12 11.1642L16 7.16421V2Z" fill="currentColor"/><Path d="M7.16421 8H2V16H7.16421L11.1642 12L7.16421 8Z" fill="currentColor"/><Path d="M16 22.25V16.8358L12 12.8358L8 16.8358V22.25H16Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M22 16H16.8358L12.8358 12L16.8358 8H22V16ZM20 10H17.6642L15.6642 12L17.6642 14H20V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGamepadControlsRight;
